<template>
  <span :class="$style['wrapper']">
    <span v-if="link.url">
      <router-link :to="link.url">
        <span>
          {{ link.displayName }}
        </span>
        <span :class="$style['arrow-wrapper']">
          <ds-arrow-icon
            v-if="drawArrow"
            :default-rotation="0"
            fill="#43cea2"
          />
        </span>
      </router-link>
    </span>
    <span v-else>
      <span :class="{ [$style['breadcrumbs']]: first, [$style['breadcrumbs--active']]: !first }">
        {{ link.displayName }}
      </span>
    </span>
  </span>
</template>

<script>
import DsArrowIcon from "../../icons/ds-arrow-icon";

export default {
  name: "BreadcrumbsItem",
  components: {
    DsArrowIcon
  },
  props: {
    link: {
      type: Object,
      default: () => {}
    },
    drawArrow: {
      type: Boolean,
      default: false
    },
    first: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" module>
@import "../../../scss/_variables.scss";

.breadcrumbs--active {
  font-weight: 600;
}
.breadcrumbs {
  font-weight: 500;
}
.wrapper {
  a {
    color: $black-blue-color !important;
    display: flex;
    align-items: center;
  }
}
.arrow-wrapper {
  margin: 0px 3px;
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/widgets/ds-breadcrumbs/breadcrumbs-item.vue